export default function ContactFooter() {
  return (
    <footer className="w-full bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 pt-24 md:pt-32 pb-16 md:pb-20">
        {/* Top rule */}
        <div className="w-full h-px bg-foreground-50/10 mb-16 md:mb-20"></div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-16">
          {/* Address */}
          <div>
            <h4 className="font-label text-xs text-foreground-400 tracking-widest uppercase mb-5">
              Address
            </h4>
            <div className="space-y-1.5">
              <p className="text-sm text-foreground-200 leading-relaxed">
                Partizanu g. 61-806
              </p>
              <p className="text-sm text-foreground-200 leading-relaxed">
                Kaunas, 49282
              </p>
              <p className="text-sm text-foreground-200 leading-relaxed">
                Lithuania
              </p>
            </div>
          </div>

          {/* Phone */}
          <div>
            <h4 className="font-label text-xs text-foreground-400 tracking-widest uppercase mb-5">
              Phone
            </h4>
            <p className="text-sm text-foreground-200 leading-relaxed">
              +370 66806319
            </p>
          </div>

          {/* Email */}
          <div>
            <h4 className="font-label text-xs text-foreground-400 tracking-widest uppercase mb-5">
              Email
            </h4>
            <p className="text-sm text-foreground-200 leading-relaxed">
              ceo@eilasa.com
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-20 md:mt-28 pt-8 border-t border-foreground-50/6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} EILASA, UAB. All rights reserved.
          </p>

          {/* Minimal geometric mark */}
          <div className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 bg-primary-500/60"></div>
            <div className="w-1 h-4 bg-foreground-50/10"></div>
            <div className="w-1.5 h-1.5 bg-accent-500/60 rounded-full"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}